export function decodeSegment(segment: string): string | null {
  if (/%(?![a-f\d]{2})/i.test(segment)) return null;

  const decoded = new URLSearchParams(
    `v=${segment.replaceAll("&", "%26").replaceAll("+", "%2B")}`,
  ).get("v");
  return decoded === null || decoded.includes("\uFFFD") ? null : decoded;
}
